module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么作者直接关闭了我提的 issue")]), _vm._v(" "), _c('p', [_vm._v("任何不认真提问题，浪费维护者时间的只有这样处理。")]), _vm._v(" "), _c('p', [_vm._v("维护者其实没有义务做外包一样回答问题，况且部分问题实在是过于马虎，看了简直是让人生气呐：")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("做为程序员，居然能问出这样的问题？！")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-872cfe78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-872cfe78"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-close-my-issue-23.vue
// module id = 2377
// module chunks = 183